/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="93.84" height="95.58" viewBox="0 0 93.84 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="b87ee8db-0075-45ec-82d2-8ca3c849a8f8" x="0" y="0" width="93.84" height="95.58" maskUnits="userSpaceOnUse">
            <g transform="translate(-30.5 -29)">
              <polygon points="30.5 124.58 124.34 124.58 124.34 29 30.5 29 30.5 124.58" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <path d="M117.5,29H90.63a6.84,6.84,0,0,0-6.84,6.84V53.23a6.85,6.85,0,0,0,6.84,6.6h4.19V66.4a1.25,1.25,0,0,0,2,.84l8.73-7.41H117.5A6.88,6.88,0,0,0,124.34,53V35.84A6.84,6.84,0,0,0,117.5,29ZM90.63,31.5H117.5a4.34,4.34,0,0,1,4.34,4.34V53a4.37,4.37,0,0,1-4.34,4.34H105a1.27,1.27,0,0,0-.66.29l-7,5.95v-5a1.25,1.25,0,0,0-1.25-1.25H90.63A4.34,4.34,0,0,1,86.29,53V35.84A4.34,4.34,0,0,1,90.63,31.5Z" transform="translate(-30.5 -29)" fill="#0e497b"/>
          <path d="M113,46.88a2.31,2.31,0,1,0-2.31-2.31A2.3,2.3,0,0,0,113,46.88" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M104.07,46.88a2.31,2.31,0,1,0-2.31-2.31,2.3,2.3,0,0,0,2.31,2.31" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M95.18,46.88a2.31,2.31,0,1,0-2.3-2.31,2.3,2.3,0,0,0,2.3,2.31" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M59.6,33H36.54a6,6,0,0,0-6,6V54a6.07,6.07,0,0,0,6,5.82H46.69l7.43,6.31.1.08a1.25,1.25,0,0,0,2-1V59.83H59.6a6,6,0,0,0,6.05-6V39.07A6.05,6.05,0,0,0,59.6,33Zm-23.06,2.5H59.6a3.55,3.55,0,0,1,3.55,3.55V53.79a3.54,3.54,0,0,1-3.55,3.54H54.8a1.24,1.24,0,0,0-1.12,1.24v3.91L48,57.63a1.24,1.24,0,0,0-.8-.3H36.54A3.57,3.57,0,0,1,33,53.79V39.07A3.54,3.54,0,0,1,36.54,35.52Z" transform="translate(-30.5 -29)" fill="#0e497b"/>
          <path d="M40.45,48.54a2,2,0,1,1,2-2,2,2,0,0,1-2,2" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M48.07,48.54a2,2,0,1,1,2-2,2,2,0,0,1-2,2" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <path d="M55.69,48.54a2,2,0,1,1,2-2,2,2,0,0,1-2,2" transform="translate(-30.5 -29)" fill="#ffb81c" fillRule="evenodd"/>
          <g mask="url(#b87ee8db-0075-45ec-82d2-8ca3c849a8f8)">
            <path d="M86.29,76.42H63.9V110H86.29Zm-2.5,2.5v28.6H66.4V78.92Z" transform="translate(-30.5 -29)" fill="#0e497b"/>
          </g>
          <g mask="url(#b87ee8db-0075-45ec-82d2-8ca3c849a8f8)">
            <path d="M78.16,116.05A3.07,3.07,0,1,1,75.1,113a3.06,3.06,0,0,1,3.06,3.06" transform="translate(-30.5 -29)" fill="#0e497b" fillRule="evenodd"/>
          </g>
          <g mask="url(#b87ee8db-0075-45ec-82d2-8ca3c849a8f8)">
            <path d="M91.14,69.09H59.05a1.25,1.25,0,0,0-1.25,1.25v53a1.25,1.25,0,0,0,1.25,1.25H91.14a1.25,1.25,0,0,0,1.25-1.25v-53A1.25,1.25,0,0,0,91.14,69.09Zm-1.25,2.5v50.49H60.3V71.59Z" transform="translate(-30.5 -29)" fill="#0e497b"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithTwoWordBubblesIcon';

export default Icon;
